//@flow
import React from 'react';
import {Tooltip} from 'react-tippy';
import s from './ExtraBar.less';
import {percentOfTotalNotFixed, percentOfTotal} from '../../../helpers';

type Props = {
  data: Object,
  totalFobTooling: number,
};

const ExtraBar = ({
  absoluteSectionCost,
  section,
  totalFobTooling,
  totalFobwithoutTooling,
  toolingCost,
  otherAdjustmentCost,
}: Props) => {
  if (!absoluteSectionCost) return null;

  const maxPercentToDisplay = 0.024;
  const absPercentOfFOB = percentOfTotal (
    totalFobwithoutTooling,
    absoluteSectionCost
  );

  const percentOfFOB = section === 'Other Adjustment Cost'
    ? '-' + absPercentOfFOB
    : absPercentOfFOB;

  const sectionCost = section === 'Other Adjustment Cost'
    ? '-' + absoluteSectionCost.toFixed (2)
    : absoluteSectionCost.toFixed (2);

  //Sets the width of the invisible bar that determines where the bar is located.
  //There needs to be an offset of the otherAdjustmentCost to bring so that the Other Adjustment Cost bar
  //ends at the end of the other FOB sectons
  const invisibleBarWidth = percentOfTotalNotFixed (
    totalFobTooling,
    totalFobwithoutTooling + otherAdjustmentCost
  );
  return (
    <div className={`${s.extraBarWrapper}`}>
      {toolingCost > 0 &&
        <span
          className={`${s.blockInvisible}`}
          style={{
            width: invisibleBarWidth,
          }}
        />}
      <Tooltip
        key={section}
        followCursor={true}
        html={
          <div className={`${s.toolTip}`}>
            <strong>
              {section}
              :
              {` `}
              {sectionCost < 0
                ? `-$${absoluteSectionCost.toFixed (2)}`
                : `$${absoluteSectionCost.toFixed (2)}`}
              {' '}
              {`(${percentOfFOB})`}
            </strong>
          </div>
        }
        trigger="mouseenter"
      >
        <span
          className={`${toolingCost > 0 ? s.block : s.blockNoTooling} ${s[section.split (' ')[0]]}`}
          style={{
            width: percentOfTotalNotFixed (
              totalFobTooling,
              absoluteSectionCost
            ),
          }}
        >
          <span className={`${s.value}`}>
            {absoluteSectionCost / totalFobTooling > maxPercentToDisplay &&
              !isNaN (absoluteSectionCost / totalFobTooling)
              ? percentOfFOB
              : ''}
          </span>
        </span>
      </Tooltip>
    </div>
  );
};

export default ExtraBar;



// WEBPACK FOOTER //
// ./src/components/StackedBarChart/ExtraBar/ExtraBar.js